const playlistsRect=[
    {
    id:1,
    imgURL:"https://uploads-ssl.webflow.com/5e36e6f21212670638c0d63c/5e39d85cee05be53d238681a_likedSongs.png",
    name:"Liked Songs"
},
{
    id:2,
    imgURL:"https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebb19af0ea736c6228d6eb539c/1/en/large",
    name:"Daily Mix 1"
},
{
    id:3,
    imgURL:"https://dailymix-images.scdn.co/v2/img/ab6761610000e5eb64575cc66fdce98eba7cee22/2/en/default",
    name:"Daily Mix 2"
},
{
    id:4,
    imgURL:"https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebc36dd9eb55fb0db4911f25dd/3/en/default",
    name:"Daily Mix 3"
},
{
    id:5,
    imgURL:"https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebb894ef9fa437b0389c5567cc/4/en/default",
    name:"Daily Mix 4"
},
{
    id:6,
    imgURL:"https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebcb6926f44f620555ba444fca/5/en/default",
    name:"Daily Mix 5"
},
];

export default playlistsRect;